// material
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

// components
import { MyAccountProfileInfoHeader } from './my-account-profile-info-header'
import { ProfileInfoItem } from '$common/profile-info-item'
// Localization
import { t } from '$i18n'
import { useClientUser } from '$logic/client-user/react-hook'
import { openEditBio, openEditUsername } from '$logic/router'

const StyledBox = styled(Box)`
  background-color: white;
  margin: 5px 0;
  padding: 10px 0;
  border-radius: 25px 25px 15px 15px;
  filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.1));
`

export function MyAccountProfileInfo() {
  const user = useClientUser()
  return (
    // TODO: CHECK IF COULD BE REPLACED BY ContactInfoItem COMPONENT
    <StyledBox>
      <MyAccountProfileInfoHeader />
      <ProfileInfoItem
        placeholder={t('myAccount.addUserName')}
        label={t('user.username')}
        value={user?.username ? `@${user.username}` : null}
        onClick={() => {
          if (user?.id) openEditUsername()
        }}
      />
      <ProfileInfoItem
        placeholder={t('myAccount.addBio')}
        label={t('user.bio')}
        value={user?.bio}
        onClick={() => {
          if (user?.id) openEditBio()
        }}
      />
    </StyledBox>
  )
}
